import React from 'react';
import PropTypes from 'prop-types';
import ItemTitle from './ItemTitle';
import ItemDate from './ItemDate';

const Item = ({ weatherAlert }) => {
  const { weatherAlertId: id, title, issuanceTime, endTime } = weatherAlert;
  return (
    <div className="box-list" item-id={id}>
      <ItemTitle {...{ expired: endTime && new Date(`${endTime}Z`) < new Date(), id, title }} />
      <ItemDate {...{ issuanceTime, endTime }} />
    </div>
  );
};

Item.propTypes = {
  weatherAlert: PropTypes.shape({
    [PropTypes.string]: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  }).isRequired,
};

export default Item;
